import { render, staticRenderFns } from "./CheckboxOutline.vue?vue&type=template&id=b871d4b0&"
import script from "./CheckboxOutline.vue?vue&type=script&lang=js&"
export * from "./CheckboxOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports